// extracted by mini-css-extract-plugin
module.exports = {"trigger":"TermsModalLink_trigger__uuMZQ","modalBody":"TermsModalLink_modalBody__WonP8"};